<script>
export default {
	data: () => {
		return {
			copyrightDate: new Date().getFullYear(),
			projectName: 'MFD Solutions',
		};
	},
};
</script>

<template>
	<div class="flex justify-center items-center text-center">
		<div class="font-general-regular text-lg text-ternary-light">
			&copy; {{ copyrightDate }} {{ projectName }}. All rights reserved.
		</div>
	</div>
</template>

<style lang="scss" scoped></style>
